
<template>
<b-container fluid class="bv-example-cambioc">
        <b-img class="logooc" :src="logo"></b-img>
           <b-row>
             <b-col  cols="12" sm="12" md="6" lg="6" class="contenido-login404">
             <b-img class="caraa" :src="cara"></b-img>
             <label class="number">404</label>
             </b-col>
             <b-col  cols="12" sm="12" md="6" lg="6" class="contenido-login404s" >
                <h6 class="poppins-semi-bold-orange-white-20px">Error 404</h6>
                <h1 class="no-encontramos-lap">No encontramos la<br>
                  página que estabas<br>
                  buscando...</h1>
                <h5 class="poppins-semi-bold-orange-white-20px">Lo sentimos, la página que estás buscando no existe o <br>
                ha sido movida.</h5>
                <div @click="ingreso()" >
            <b-button block class="boton-ingresoo404"  ><label  class="ir-al-inicio-de-sesin">Ir al inicio de sesión</label></b-button>
            </div>
             </b-col>
            </b-row>
</b-container>
  
</template>

<script>

export default {
  name: "Error4041",
   components: {},
  
  props: [
    "logo",
    "cara",
    "desgrade",
  ],
  data() {
        return {
            
        }
    },
   methods: {
        
        async ingreso() {
           this.$router.push('/login');
        }
    }, 
};

</script>

<style>
.number {
    color: var(--blue-violet);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xll);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 36px;
    white-space: nowrap;
    margin-top: 12%;
    margin-left: -12%;
    position:absolute;
}
.bv-example-cambioc {
    /* background-color: var(--blue-violet);
    margin: 0;
    max-width: 100% !important;
    height: 753px !important;
     text-align: center; */
     background-color: var(--blue-violet);
     height: 100vh;
       text-align: center;
}
.logooc {
    margin-top: 3%;
}
.no-encontramos-lap {
  color: var(--orange-white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-ll);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 60px;
  margin-top: 3%;
   margin-bottom: 4%;
  min-height: 193px;
  white-space: nowrap;
}
.contenido-login404s{
  text-align:left;
  margin-top:3% !important;
}
.boton-ingresoo404{
    margin-top:3%;
    width:36%;
    background-color: var(--white) !important;
    border-radius: 10px !important;
    height: 50px;
    text-align: center;
    border-color:transparent !important ;
}
.boton-ingresoo404:hover{
    background: var(--hawkes-blue) !important;
}
.ir-al-inicio-de-sesin {
    color: var(--blue-violet);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-sl);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 14px;
    
}
.caraa{
      margin-top: 17%;
    margin-left: 27%;
}
@media (max-width: 669px) {
.caraa {
    margin-top: 12%;
    width: 56% !important;
     margin-left: 0%; 
}
.contenido-login404s{
    text-align:center !important;
}
.boton-ingresoo404{
    width: 80% !important;
}
    .number {
        margin-top: 17% !important;
        margin-left: -32.5% !important;
    }

    .no-encontramos-lap {
  font-size: 30px;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: 3%;
   margin-bottom: 2% !important;
  min-height: 110px;
  white-space: nowrap;
}
}
@media (max-width: 1922px) {
/* .bv-example-cambioc {
    height: 969px !important;
} */
.number {
        margin-top: 11.5%;
    margin-left: -9.5%;
}
}
@media (max-width: 1540px) {
/* .bv-example-cambioc {
    height: 753px !important;
} */
.number {
    margin-top: 10.5%;
    margin-left: -12.2%;
}
.caraa{
    margin-top: 14%;
}
}
@media (max-width: 1370px) {
        .logooc {
    margin-top: 2%;
    width: 16%;
}
.caraa {
    margin-top: 13%;
    width: 50%;
}
.contenido-login404s  {
    margin-top: 4% !important;
}
.number {
    margin-top: 10.5%;
    margin-left: -13.3%;
}
    }
@media (max-width: 1280px) {
  /* .bv-example-cambioc {
    height: 609px !important;
} */
.contenido-login404s {
    margin-top: 3% !important;
}
.number {
        margin-top: 10%;
    margin-left: -12.5%;
}
}
@media (max-width: 1100px) {
   /* .bv-example-cambioc {
    height: 506px !important;
} */
.caraa {
    margin-top: 12%;
    width: 54%;
}
.no-encontramos-lap {
    /* font-size: 40px; */
    margin-top: 2%;
    margin-bottom: 2%;
}
.boton-ingresoo404 {
    margin-top: 2%;
    height: 37px;
}
}
</style>